const Impresum = () => {
  return (
    <>
      <div className="w-full h-full bg-white pb-8">
        <div className="text-center pt-36 h-full">
          <h1 className="text-4xl mb-10" style={{ fontFamily: 'lato-black' }}>
            Impresum:
          </h1>
          <h2 className="text-6xl mb-10" style={{ fontFamily: 'lato-black' }}>
            Portal Dnevno.me
          </h2>
          <div className="mb-8">
            <p className="mb-2">Vlasnička struktura</p>
            <p>Osnivač:</p>
            <p className="text-l mb-2" style={{ fontFamily: 'lato-black' }}>
              Dnevno d.o.o. Podgorica
            </p>
            <p>Povezana lica:</p>
            <p className="text-l mb-2" style={{ fontFamily: 'lato-black' }}>
              Savana Commercial Retail d.o.o. Podgorica
            </p>
          </div>
          <div className="mb-8">
            <p>PIB</p>
            <p className="text-l" style={{ fontFamily: 'lato-black' }}>
              03409791
            </p>
          </div>
          <div className="mb-8">
            <p>Adresa: </p>
            <p className="text-l" style={{ fontFamily: 'lato-black' }}>
              Svetlane Kane Radević, br.3 - Podgorica
            </p>
          </div>
          <div className="mb-8">
            <p>Izvršni direktor: </p>
            <p className="text-l" style={{ fontFamily: 'lato-black' }}>
              Veselin Mijač
            </p>
          </div>
          <div className="mb-8">
            <p>Glavni i odgovorni urednik:</p>
            <p className="text-l" style={{ fontFamily: 'lato-black' }}>
              Jelena Ćetković
            </p>
          </div>
          <div className="mb-8">
            <p>Kontakt:</p>
            <p className="text-l" style={{ fontFamily: 'lato-black' }}>
              redakcija@dnevno.me, marketing@dnevno.me
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Impresum
